import React, { useEffect } from 'react';
import { Alert as ReactStrapAlert } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  HIDE_ALERT_DEFAULT_TIME_IN_SECONDS,
  ALERT_ICON_MAP,
} from '../../../constants/AlertConstants';
import Icon from '../Icon/Icon';
import { hideAlert } from '../../../actions/alert.action';
import { EAlertType } from '../../../types/alert.types';
import { IInitialState } from '../../../types/initialState.types';
import styles from './Alert.module.css';

const Alert = () => {
  const dispatch = useDispatch();
  const { show, message, type, hideInSeconds } = useSelector(
    (state: IInitialState) => state?.alert
  );

  const onDismiss = () => {
    dispatch(hideAlert());
  };

  useEffect(() => {
    if (type !== EAlertType.ERROR) {
      const hideTimeout = setTimeout(() => {
        onDismiss();
        clearTimeout(hideTimeout);
      }, (hideInSeconds ?? HIDE_ALERT_DEFAULT_TIME_IN_SECONDS) * 1000);
      return () => {
        clearTimeout(hideTimeout);
      };
    }
  }, [type, hideInSeconds]);

  const { color: iconColor, name: iconName } =
    ALERT_ICON_MAP[type || EAlertType.INFO];

  return (
    <>
      {message && show && (
        <ReactStrapAlert
          className={`d-flex align-items-center ${styles.alert} position-absolute mb-0`}
          color={type}
          isOpen={show}
          fade={true}
        >
          <Icon
            name={iconName}
            fill={iconColor}
            width={20}
            height={20}
            className={styles.alertIcon}
          />
          <span className={styles.alertMessage}>{message}</span>

          {type === EAlertType.ERROR && (
            <Icon
              name="close"
              className={styles.alertClose}
              width={20}
              height={20}
              fill="#E51635"
              fillOpacity="0.5"
              onClick={onDismiss}
              role="button"
            />
          )}
        </ReactStrapAlert>
      )}
    </>
  );
};

export default Alert;
